// extracted by mini-css-extract-plugin
export default {"clickableCountry":"CountryButton_clickableCountry__tincg"};